import * as React from 'react';

import Blog from './Blog'
import packageMetadata from '../../package.json'

import {
  AppStyles,
  ToolbarStyles,
  AppBarStyles,
  ContentStyles
} from '../styles/AppStyles'

import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';


const Styles = theme => ({
  ...AppStyles(theme),
  ...ToolbarStyles(theme),
  ...AppBarStyles(theme),
  ...ContentStyles(theme)
})

const useStyles = makeStyles(Styles);

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {`Copyright © Jimy Ma ${new Date().getFullYear()} · v${packageMetadata.version}`}
    </Typography>
  );
}





const sections = [
  ["about", "About"],
  ["news", "News"],
  ["education", "Education"],
  ["experience", "Experience"],
  ["projects", "Projects"],
  ["publications", "Publications"],
  ["teaching", "Teaching"],
  ["service", "Service"],
  ["awards", "Awards"],
];

export default function Dashboard({darkMode, onToggleTheme}) {
  const classes = useStyles();
  const navigateTo = sectionId => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({behavior: "smooth", block: "start"});
      window.history.replaceState(null, "", "#" + sectionId);
    }
  };
  return (
    <div className={classes.root}>

      <CssBaseline />
      <AppBar
        position="fixed"
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            JimyMa's Homepage
          </Typography>
          <nav className={classes.quickNavigation} aria-label="Quick navigation">
            {sections.map(([id, label]) => (
              <Button
                key={id}
                color="inherit"
                className={classes.navButton}
                onClick={() => navigateTo(id)}
              >
                {label}
              </Button>
            ))}
          </nav>
          <Tooltip title={darkMode ? "Switch to light mode" : "Switch to dark mode"}>
            <IconButton
              color="inherit"
              className={classes.toolbarAction}
              onClick={onToggleTheme}
              aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
            >
              {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <main className={classes.content}>
          <Container maxWidth="lg" className={classes.container}>
            <Blog/>
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
      </main>
    </div>
  );
}
